package dev.akshaychordiya.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.akshaychordiya.content.Mentoring
import dev.akshaychordiya.content.interests
import dev.akshaychordiya.fadeUp
import dev.akshaychordiya.toSitePalette
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span

val InterestRowStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.Flex)
        .flexWrap(FlexWrap.Wrap)
        .gap(0.6.cssRem)
        .margin(bottom = 1.25.cssRem)
}

/**
 * Deliberately not built from the Talks page's `ChipStyle`.
 *
 * That one is a filter control - pointer cursor, hover recolour, press-down scale. Reusing it here would promise
 * these chips do something when clicked, and they don't. These are labels that happen to be chip-shaped.
 */
val InterestChipStyle = CssStyle.base {
    Modifier
        .padding(topBottom = 0.4.cssRem, leftRight = 0.9.cssRem)
        .borderRadius(2.cssRem)
        .fontSize(0.9.cssRem)
        .gap(0.4.cssRem)
        .display(DisplayStyle.Flex)
        .alignItems(org.jetbrains.compose.web.css.AlignItems.Center)
        .backgroundColor(colorMode.toSitePalette().surface)
        .color(colorMode.toSitePalette().text)
        .border(1.px, LineStyle.Solid, colorMode.toSitePalette().border)
}

/**
 * The interests block, as a widget so `About.md` can place it with
 * `{{{ .components.widgets.Interests }}}`.
 *
 * The closing line's booking link is built from [Mentoring.TOPMATE_PROFILE] rather than typed into the Markdown, so
 * the profile URL stays in exactly one place.
 */
@Composable
fun Interests() {
    val palette = ColorMode.current.toSitePalette()

    Div(InterestRowStyle.toAttrs()) {
        interests.forEachIndexed { index, interest ->
            Div(InterestChipStyle.toModifier().fadeUp(index).toAttrs()) {
                Span(attrs = Modifier.attrsModifier { attr("aria-hidden", "true") }.toAttrs()) {
                    SpanText(interest.emoji)
                }
                SpanText(interest.label)
            }
        }
    }

    Div(attrs = Modifier.fadeUp(interests.size).toAttrs()) {
        SpanText("Happy to talk about any of it. There's a free discovery call on my ", Modifier.color(palette.subdued))
        Link(path = Mentoring.TOPMATE_PROFILE, text = "Topmate")
        SpanText(" - come and say hello.", Modifier.color(palette.subdued))
    }
}
